import React, {useRef} from 'react';
import styles from './content.module.css';
import useInitialfocus from '../../menu/focus';

function Content({caption}) {
  const {content, child} = styles;
  const mainRef = useRef(null);
  useInitialfocus(mainRef);

  return (
    <div ref={mainRef} tabIndex="-1" className={content}>
      <span className={child}>{caption}</span>
    </div>
  );
}

export default Content;
